import { axiosInstance } from "@/services/core/base";
import Core from "@/services/core";

class QrCodes extends Core {
    constructor(axios = axiosInstance) {
        super(axios);
    }

    fetchAll(params = "") {
        return this.get("insurance/qr-code" + (params ? "?" + params : ""));
    }

    fetchOne(id) {
        return this.get(`insurance/qr-code/${id}`);
    }

    create(body) {
        return this.post("insurance/qr-code", body);
    }

    update(id, body) {
        return this.put(`insurance/qr-code/${id}`, body);
    }

    disable(id) {
        return this.update(id, { status: "disabled" });
    }

    export(params = "") {
        return this.get("insurance/qr-code/export" + (params ? "?" + params : ""), {
            responseType: "blob",
        });
    }
}

export default QrCodes;
